<template>
  <b-tab title="Ana Ürün Listesi" active>
    <b-row class="border">
      <b-col cols="2">
        Id
      </b-col>
      <b-col cols="2">
        Barcode
      </b-col>
      <b-col cols="2">
        Kat Sayısı
      </b-col>
      <b-col cols="2">
        Yüzde İlave
      </b-col>
      <b-col cols="2">
        Sabit İlave
      </b-col>
    </b-row>
    <b-row v-for="subProduct in subProducts" :key="subProduct.id" class="border">
      <b-col cols="2">
        {{ subProduct.id }}
      </b-col>
      <b-col cols="2">
        {{ subProduct.barcode }}
      </b-col>
      <b-col cols="2">
        {{ subProduct.pivot.multiple }}
      </b-col>
      <b-col cols="2">
        {{ subProduct.pivot.percent_sing }} {{ subProduct.pivot.percent }}
      </b-col>
      <b-col cols="2">
        {{ subProduct.pivot.fixed_sing }} {{ subProduct.pivot.fixed }}
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
export default {
  name: "SubProductTab",
  props: {
    product: {
      type: Object,
      required: true
    },
    subProducts: {
      type: Array,
      required: true
    }
  }
}
</script>